import React, {useState} from 'react';

//Styles
import Styles from './TextInput.module.scss';

//Utils
import PropTypes from 'prop-types';

const TextInput = React.forwardRef(({className, validationError = null, name, value, disabled, setInputValue, type = 'text', ...props}, ref) => {
    const [isFocused, setFocused] = useState(false);

    const changeHandler = (eventValue) => {
        setInputValue(eventValue)
    };

    const onFocus = () => {
        setFocused(true)
    };

    const onBlur = () => {
        setFocused(false)
    };

    return (
        <div ref={ref} className={Styles.container}>
            {
                !!validationError ? (
                    <label className={Styles.error}>
                        {validationError}
                    </label>
                ) : (
                    <label
                        data-test-isfocused={isFocused}
                        className={isFocused || (value && value.length !== 0) ? Styles.focus : Styles.unFocus}
                    >
                        {name}
                    </label>
                )
            }
            <input
                style={{borderBottom: validationError ? '1px solid red' : ''}}
                disabled={disabled}
                value={value || ''}
                onChange={(e) => changeHandler(e.target.value)}
                onFocus={onFocus}
                onBlur={onBlur}
                type={type}
                className={className}
                data-testid={name ? `input-${name}` : props?.['data-testid']}
            />
        </div>
    );
});

TextInput.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    type: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string.isRequired,
    setInputValue: PropTypes.func
};

export default TextInput
